import React, { useEffect, useRef, useState } from 'react'
import CustomModal from './Modal';
import styles from "./Environmentpanel.module.css"
import { create_environment_file_Api, delete_environment_api, delete_environment_file_Api, get_all_environment_file_Api, update_environment_Api } from '../../dashboardapi';
import data from "../../json/Config.json"
import { useToast } from '@chakra-ui/react';


const Environmentfiles = ({ showModal, index, file, setshowdetails, fetchenvi }) => {
    const [dragging, setDragging] = useState(false);
    const fileInputRef = useRef(null);
    const [inputFiles, setInputFiles] = useState([]);
    const [environmentTitle, setEnvironmentTitle] = useState("")
    const [allEnvironmentFiles, setAllEnvironmentFiles] = useState([])
    const [rename, setRename] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [filename, setFilename] = useState("")

    const toast = useToast();

    useEffect(() => {
        fetchallenvironmentfiles(file);
    }, [])

    useEffect(() => {
        setFilename(file.name)
    }, [file.name])

    const fetchallenvironmentfiles = async (file) => {
        let response = await get_all_environment_file_Api(file.uuid)
        if (response.data) {
            // console.log(response.data);
            if (response.data.length > 0) {
                setAllEnvironmentFiles(response.data)
            } else {
                // toast({
                //     title: "No files Uploaded",
                //     description: "Please upload files to the environment",
                //     status: "warning",
                //     duration: 2000,
                //     isClosable: "true"
                // })
                setAllEnvironmentFiles([])
            }
        } else {
            const error = response.error.message || "An error Occured"
            toast({
                title: "Problem getting Environmentfiles",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        handleFiles(files); // Handle dropped files
    };

    const handleFiles = (files) => {
        const fileslist = Array.from(files)
        setInputFiles((prev) => [...prev, ...fileslist])
    };

    const handleClick = () => {
        fileInputRef.current.click(); // Trigger file input click
    };

    const handleChange = (e) => {
        setEnvironmentTitle(e.target.value)
    }

    const handleDelete = async (envid, fileid) => {
        let result = await delete_environment_file_Api(envid, fileid);
        if (result.data) {
            toast({
                title: "Files deleted successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchallenvironmentfiles(file)
        }
        else {
            let error = result.error.message || "An error Occured"
            toast({
                title: "Problem deleting files",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })

        }
    }

    const handlenewDelete = (todelete) => {
        setInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const Renametitle = async (id, name) => {
        try {
            const result = await update_environment_Api(id, name);
            if (result.data) {
                fetchenvi()
            } else {
                const errorMessage = result.error?.message || "An error occurred";
                toast({
                    title: "Problem updating environment",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem updating environment",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const updateFiles = async (e) => {
        e.preventDefault();
        try {
            if (environmentTitle) {
                Renametitle(file.uuid, environmentTitle);
            }
            let result = await create_environment_file_Api(file.uuid, inputFiles);
            if (result.data) {
                toast({
                    title: "Environment updated successfully",
                    description: "",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                fetchallenvironmentfiles(file)
                setInputFiles([])
                setshowdetails({ show: false })
            } else {
                const errorMessage = result.error.message || "An error occurred"
                toast({
                    title: "Problem uploading files",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem uploading files",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    // console.log(showDeleteModal);

    const handleenvdelete = async () => {
        try {
            let result = await delete_environment_api(file.uuid);
            if (result.data) {
                // console.log(result);
                toast({
                    title: "Environment deleted successfully",
                    description: result.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                setShowDeleteModal(false)
                setshowdetails({ show: false })
                fetchenvi();
            } else {
                console.log(result.error);

                let error = result.error.message || "An error occurred"
                toast({
                    title: "Problem deleting environment",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        }
        catch (error) {
            toast({
                title: "Problem deleting environment",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    return (
        <>
            <div className={styles.modalbackdrop}>
                <CustomModal show={showModal}>
                    <div className={styles.modalouter}>
                        <div style={{ padding: '24px', borderRight: '0.6px solid #CCCBD3', width: '50%' }}>
                            <div className={styles.modalheader}>
                                {data.environmenttitle}
                            </div>
                            <form className={styles.formouter} method='POST' onSubmit={updateFiles}>
                                <div className={styles.inputname} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start" }}>
                                    <div style={{ width: "100%", display: "flex", gap: "10px", justifyContent: 'space-between' }}>
                                        <label >Title</label>
                                        <div style={{ color: "red" }}>
                                            {!rename ? <div onClick={() => setRename(true)} style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: "10px", fontSize: "14px" }}>Rename</div> : <div onClick={() => setRename(false)} style={{ width: "100%", display: "flex", justifyContent: "center", color: "red", fontSize: "14px" }}>Cancel</div>}
                                        </div>

                                    </div>
                                    <div style={{ width: "100%" }}>
                                        {!rename ?
                                            <p style={{ fontSize: "18px", fontWeight: "600", marginBottom: "20px" }}>{filename}</p> :
                                            <><input type='text' name='environment_name' maxLength={50} onChange={handleChange} placeholder='Enter Environment Name' required /><span></span></>}
                                    </div>
                                </div>
                                <div className={`${styles.inputdiv} ${dragging ? styles.dragging : ''}`} onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}>
                                    {dragging ? (
                                        // When dragging, show this content
                                        <div style={{ height: '133px' }}>
                                            Drag your file here
                                        </div>
                                    ) : (
                                        <>
                                            <p>
                                                <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"} alt='' />
                                            </p>
                                            <div>Upload your files</div>
                                            <p>Drag and drop your files here or <a onClick={handleClick} >choose files</a></p>
                                            <input
                                                type='file'
                                                name='project_name'
                                                placeholder='Enter Project Name'
                                                ref={fileInputRef}
                                                style={{ display: 'none' }} // hide the file input
                                                multiple
                                                onChange={(e) => handleFiles(e.target.files)}
                                                accept='.tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls'
                                            />
                                        </>
                                    )}
                                </div>

                                <div className={styles.actionbtn}>
                                    <button className={styles.btn1} onClick={() => setshowdetails({ show: false })}>Cancel</button>
                                    <button className={styles.btn2} type='submit'>Update</button>
                                </div>
                            </form>
                            <div className={styles.deleteenvbtn}>
                                <button onClick={() => setShowDeleteModal(true)} style={{ fontSize: "14px" }}>Delete Environment</button>
                            </div>
                        </div>

                        {/* New files to Upload */}
                        {
                            inputFiles && inputFiles.length > 0 && <div div style={{ paddingBottom: '24px', width: '50%' }}>
                                <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid #CCCBD3' }}>
                                    Files to Upload
                                </div>
                                <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                                    {inputFiles ? inputFiles.map((indfile, id) => (
                                        <>
                                            <div key={id}>
                                                <span style={{ width: "70%" }}>
                                                    <p>{indfile.name}</p>
                                                    <p style={{ fontSize: '0.75rem', color: '#5C5B60' }}>{indfile.type} I {indfile.size < 1000000 ? (indfile.size / 1024).toFixed(2) : indfile.size} {indfile.size < 1000000 ? "KB" : "MB"} </p>
                                                </span>
                                                <button onClick={() => handlenewDelete(indfile.name)}>
                                                    <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='' />
                                                </button>
                                            </div>
                                        </>
                                    )) : ""}
                                </div>
                            </div>
                        }

                        {/* Already uploaded files */}
                        <div style={{ paddingBottom: '24px', width: '50%' }}>
                            <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid #CCCBD3' }}>
                                Uploaded Files
                            </div>
                            <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                                {allEnvironmentFiles.length > 0 ? allEnvironmentFiles.map((indfile, id) => (
                                    <>
                                        {console.log(indfile.size)}
                                        <div key={id}>
                                            <span style={{ width: "70%" }}>
                                                <p>{indfile.name}</p>
                                                <p style={{ fontSize: '0.75rem', color: '#5C5B60' }}>{indfile.type} I {`${indfile.size.toFixed(2)} MB`} </p>
                                            </span>
                                            <button onClick={() => handleDelete(file.uuid, indfile.uuid)}>
                                                <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='' />
                                            </button>
                                        </div>
                                    </>
                                )) : "No files to show"}
                            </div>
                        </div>
                    </div >
                </CustomModal >
            </div >

            {showDeleteModal ? <div className={styles.secondmodalbackdrop}>
                <div className={styles.secondmodalcontent}>
                    <CustomModal show={showDeleteModal}>
                        <div style={{ padding: "40px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <h1>Do You wish to Delete Environment?</h1>
                            <div className={styles.actionbtn}>
                                <button className={styles.btn1} onClick={() => { setShowDeleteModal(false) }}>Cancel</button>
                                <button className={styles.btn2} onClick={handleenvdelete}>Delete</button>
                            </div>
                        </div>
                    </CustomModal>
                </div>
            </div> : ""}
        </>
    )

}

export default Environmentfiles;